
<template>
  <v-autocomplete
                  v-model="value"
                  v-model:search="searchText"
                  :items="lstObjects"
                  item-title="label"
                  :label="label"
                  :multiple="multiple"
                  chips
                  clearable
                  return-object
                  hide-details
                  :density="small ? 'compact' : 'default'">
    <template v-slot:no-data>
      <div class="px-4">Digite sua busca</div>
    </template></v-autocomplete>
</template>
<script>
export default {
  components: {},
  props: {
    user: Object,
    label: String,
    modelValue: Array | Object,
    lstObjects: Array,
    small: Boolean,
    multiple: Boolean,

  },
  emits: ["update:modelValue"],
  data() {
    return {
      searchText: null,
    };
  },
  created() { },
  mounted() { },
  activated() { },
  methods: {},
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {},
};
</script>
